<script>
import FormPriceHeader from '@/modules/form-details/components/form-price-header/FormPriceHeader.vue';
import InvoiceInformation from '@/modules/invoice-summary/components/invoice/InvoiceInformation';
import ReservationDetails from '@/modules/invoice-summary/components/details/ReservationDetails';
import { mapActions, mapGetters } from 'vuex';
import { CUSTOMER_SEX_TYPES, CUSTOMER_TYPES } from '@/modules/constants';

export default {
  name: 'InvoiceSummary',
  components: { ReservationDetails, InvoiceInformation, FormPriceHeader },
  computed: {
    ...mapGetters(['invoiceData', 'customer'])
  },
  methods: {
    ...mapActions([
      'setInvoiceDataAction',
      'updateInvoiceDataAction',
      'updateFormErrorAction',
      'setIsMobileAction',
      'setIsFormDetailsEditAction'
    ]),
    handleEditButton: function() {
      this.setIsFormDetailsEditAction(true);
      this.$store.commit('SET_NEXT_STEP', 2);
    }
  },
  mounted() {
    this.setIsMobileAction();
    window.scrollTo(0,0);
  }
};
</script>
<template>
  <div class="container">
    <div class="wrapper">
      <!-- PRICE ON TOP -->
      <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)" class="header-wrapper">
        <form-price-header />
      </div>

      <div class="formular step2">
        <div class="panel panel-default panel-hv-grey">
          <div class="panel-heading pl-30">
            <div><i class="fa fa-eur"></i></div>
            <span style="font-size: 18px">Bestellübersicht:</span>
          </div>
          <div id="edit-header" v-if="!customer || (customer && !customer.bsr)">
            <div class="text-right form-open">
              <a id="edit_kontakt_daten" v-on:click="handleEditButton" class="s-color">
                <i class="fa fa-edit"></i>
                Bearbeiten
              </a>
            </div>
          </div>
          <div class="panel-body" style="min-height: 1px;">
            <div class="clearfix mb-20">
              <invoice-information />
              <reservation-details />
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import 'InvoiceSummaryStyles';
</style>
